export function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router/es/PromiseUtils.js
// module id = 199
// module chunks = 0